__turbopack_context__.v({
  "className": "montserrat_bba129a6-module__TUV0iq__className",
  "variable": "montserrat_bba129a6-module__TUV0iq__variable",
});
